import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PinPage from './ks/main/PinPage';
import SuccessPage from './ks/main/SuccessPage';
import UnsubPage from './ks/main/UnsubPage';
import TermsPage from './ks/main/TermsPage';
import PrivacyPage from './ks/main/PrivacyPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PinPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/unsub" element={<UnsubPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Routes>
    </Router>
  );
}

export default App;
